module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-megaphone-ff14ab4b0a5ac90207977c831599c036.svg";